/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash b93149f9c6f2580a67ad258025d2af0e */

import { ConcreteRequest } from "relay-runtime";

export type TransactionVerifyEmailMutationInput = {
    emailVerificationToken: string;
    clientMutationId?: string | null | undefined;
};
export type verifyEmailHandlerMutationVariables = {
    input: TransactionVerifyEmailMutationInput;
};
export type verifyEmailHandlerMutationResponse = {
    readonly transactionVerifyEmail: {
        readonly __typename: string;
    } | null;
};
export type verifyEmailHandlerMutation = {
    readonly response: verifyEmailHandlerMutationResponse;
    readonly variables: verifyEmailHandlerMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "TransactionVerifyEmailMutationPayload",
            "kind": "LinkedField",
            "name": "transactionVerifyEmail",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "verifyEmailHandlerMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "verifyEmailHandlerMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/verifyEmailHandlerMutation",
            "metadata": {},
            "name": "verifyEmailHandlerMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '038df1e8cb2211f8d718a9b6dd594b40';
export default node;
